import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
var SearchReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
        };
    }
};
export default SearchReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/Searches/SearchReduxProps.ts
// module id = 459
// module chunks = 0